export const acceptIRDDashboardOrder = `
mutation MyMutation(
  $hotelId: String!
  $id: String!
  $lang: String
){
  acceptOrder(
    input: {
      hotelId: $hotelId 
      id: $id
      lang: $lang
    }) {
    message
    status
    }
}`;

export const completeIRDDashboardOrder = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $completedTime: String!
  $lang: String
){
completeOrder(
  input: {
    id: $id
    hotelId: $hotelId
    completedTime: $completedTime
    lang: $lang
  }) {
  message
  status
  }
}`;

export const delayIRDDashboardOrder = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $delayReason: String
  $lang: String
){
delayOrder(
  input: {
    id: $id
    hotelId: $hotelId
    delayReason: $delayReason
    lang: $lang
  }) {
  message
  status
  }
}`;

export const markFAndBBillAsPaid = `
mutation MyMutation(
  $billId: String!
  $hotelId: String!
  $restaurantId: String!
){
  markFAndBBillAsPaid(
  input: {
    billId: $billId
    hotelId: $hotelId
    restaurantId: $restaurantId
  }) {
  message
  status
  }
}`;

export const updateSpaOrderStatus = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $status: EnumStatus!
  $lang:String
){
updateSpaOrderState(
  input: {
    id: $id
    hotelId: $hotelId
    status: $status
    lang: $lang
  }) {
  message
  status
  }
}`;

export const updateRestaurantOrderStatus = `
mutation MyMutation(
  $id: String!
  $restaurantId: String!
  $status: String!
  $lang:String
){
  changeReservationStatus(input: {id: $id, restaurantId: $restaurantId, status: $status, lang:$lang}) {
    bookingDate
    date
    exposure
    firstName
    hotelId
    id
    isReservedForGuest
    lastName
    noOfGuests
    reserveFrom
    reserveUntil
    restaurantId
    roomNo
    status
    tableNumbers
  }
}`;

export const assignTable = `
mutation MyMutation(
  $id: String!
  $restaurantId: String!
  $lang:String
  $tableNumbers: [Int!]!
) {
  assignTable(input: {
    id: $id
    restaurantId: $restaurantId
    tableNumbers: $tableNumbers
    lang: $lang
  }) {
    bookingDate
    date
    exposure
    firstName
    hotelId
    id
    isReservedForGuest
    lastName
    noOfGuests
    reserveFrom
    reserveUntil
    restaurantId
    roomNo
    status
    tableNumbers
  }
}`;

export const createRestaurantReservation = `
mutation MyMutation (
  $hotelId:String!
  $date: String!
  $exposure: String!
  $isReservedForGuest: Boolean!
  $reserveFrom: String!
  $reserveUntil: String!
  $restaurantId: String!
  $description: String!
  $firstName: String!
  $lastName: String!
  $guestType: String!
  $noOfGuests: Int
  $roomNo: String!
  $tableNumbers: [Int!]!
  $lang:String

){
  createRestaurantReservation(input:{
    date: $date,
    exposure: $exposure, 
    hotelId: $hotelId, 
    isReservedForGuest: $isReservedForGuest, 
    restaurantId: $restaurantId, 
    reserveFrom: $reserveFrom, 
    reserveUntil: $reserveUntil, 
    description: $description, 
    firstName: $firstName, 
    guestType: $guestType, 
    lastName: $lastName, 
    noOfGuests: $noOfGuests, 
    roomNo: $roomNo, 
    lang: $lang, 
    tableNumbers: $tableNumbers})  {
    bookingDate
    date
    exposure
    firstName
    hotelId
    id
    isReservedForGuest
    lastName
    noOfGuests
    reserveFrom
    reserveUntil
    restaurantId
    roomNo
    status
    tableNumbers
  }
}`;

export const updateRestaurantReservation = `
mutation MyMutation (
  $id: String!
  $date: String!
  $exposure: String!
  $isReservedForGuest: Boolean!
  $reserveFrom: String!
  $reserveUntil: String!
  $restaurantId: String!
  $description: String!
  $firstName: String!
  $lastName: String!
  $guestType: String!
  $noOfGuests: Int
  $roomNo: String!
  $tableNumbers: [Int!]!
  $lang:String
){
  updateRestaurantReservation(input:{
    id: $id,
    date: $date,
    exposure: $exposure,
    isReservedForGuest: $isReservedForGuest, 
    restaurantId: $restaurantId, 
    reserveFrom: $reserveFrom, 
    reserveUntil: $reserveUntil, 
    description: $description, 
    firstName: $firstName, 
    guestType: $guestType, 
    lastName: $lastName, 
    noOfGuests: $noOfGuests, 
    roomNo: $roomNo, 
    lang: $lang, 
    
    tableNumbers: $tableNumbers})  {
      bookingDate
      date
      description
      exposure
      firstName
      guestType
      hotelId
      id
      isReservedForGuest
      lastName
      noOfGuests
      reserveFrom
      reserveUntil
      restaurantId
      roomNo
      status
      tableNumbers
  }
}`;

export const createRestaurantTable = `mutation MyMutation(
  $tableNumber:Int!
  $capacity:Int!
  $exposure:String!
  $duration:String!
  $hotelId:String!
  $restaurantId:String!
  $lang:String
) {
  createRestaurantTable(
    input: {
      tableNumber: $tableNumber
      capacity: $capacity
      exposure: $exposure
      duration: $duration
      hotelId: $hotelId
      restaurantId: $restaurantId 
      lang: $lang
    }) {
    capacity
    duration
    exposure
    hotelId
    restaurantId
    tableNumber
  }
}
`;

export const updateRestaurantTable = `mutation MyMutation(
  $tableNumber:Int!
  $capacity:Int!
  $exposure:String!
  $duration:String!
  $hotelId:String!
  $restaurantId:String!
  $lang:String
) {
  updateRestaurantTable(
    input: {
      tableNumber: $tableNumber
      capacity: $capacity
      exposure: $exposure
      duration: $duration
      hotelId: $hotelId
      restaurantId: $restaurantId 
      lang: $lang
    }) {
      status
      message
  }
}
`;

export const deleteRestaurantTable = `mutation MyMutation(
  $tableNumber:Int!
  $restaurantId:String!
  $lang:String
  $hotelId:String!
) {
  deleteRestaurantTable(
    input: {
      tableNumber: $tableNumber
      restaurantId: $restaurantId
      hotelId: $hotelId
      lang: $lang
      }) {
    message
    status
  }
}`;

export const deleteRestaurantReservation = `mutation MyMutation(
  $id:String!
  $restaurantId:String!
  $hotelId:String!
  $lang:String
) {
  removeReservation(
    input: {
      id: $id
      restaurantId: $restaurantId
      hotelId: $hotelId
      lang: $lang
      }) {
    message
    status
  }
}`;

export const updateHouseKeepingOrderState = `
mutation MyMutation(
  $id: String!
  $hotelId: String!
  $status: EnumStatus!
  $lang: String
){
  updateHouseKeepingOrderState(
  input: {
    id: $id
    hotelId: $hotelId
    status: $status
    lang: $lang
  }) {
  message
  status
  }
}`;

export const acceptFAndBDashboardOrder = `
mutation MyMutation(
  $hotelId: String!
  $orderId: String!
  $lang: String
  $restaurantId: String!
){
  acceptFAndBOrder(
    input: {
      hotelId: $hotelId 
      orderId: $orderId
      lang: $lang
      restaurantId: $restaurantId
    }) {
    message
    status
    }
}`;

export const declineFAndBDashboardOrder = `
mutation MyMutation(
  $hotelId: String!
  $orderId: String!
  $lang: String
  $restaurantId: String!
){
  declineFAndBOrder(
    input: {
      hotelId: $hotelId 
      orderId: $orderId
      lang: $lang
      restaurantId: $restaurantId
    }) {
    message
    status
    }
}`;

export const completeFAndBDashboardOrder = `
mutation MyMutation(
  $hotelId: String!
  $orderId: String!
  $lang: String
  $restaurantId: String!
  $completedTime: String!
){
  completeFAndBOrder(
    input: {
      hotelId: $hotelId 
      orderId: $orderId
      lang: $lang
      restaurantId: $restaurantId
      completedTime: $completedTime
    }) {
    message
    status
    }
}`;
